/**
 * * Модель запроса для установление итоговой оценки задачи
 */
export default class UpsertFinalEstimateRequest  {
	/**
	 * * Идентификатор задачи
	 */
	TaskId!: number;
	/**
	 * * Оценка времени
	 */
	Estimate!: number;
	constructor(obj?: Partial<UpsertFinalEstimateRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
